/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import { forwardRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

function forwardRefWithStatics(component, statics) {
  return hoistNonReactStatics( /*#__PURE__*/forwardRef(component), statics);
}

export { forwardRefWithStatics as default };
//# sourceMappingURL=forwardRefWithStatics.js.map
